/**
 * 原预订订单信息
 */
import React from 'react';
import intl from 'react-intl-universal';

import ContentBlock, { FormItem } from '@/components/Reservation/ContentBlock';
import { useDetailData } from '@/pages/reservation/reverseRollback/helper';

const Index = () => {
  const { resvNo } = useDetailData();

  return (
    <ContentBlock title={intl.get('drawer_extension_rollback_block_order')}>
      <FormItem label={intl.get('drawer_extension_rollback_item_no')}>{resvNo}</FormItem>
    </ContentBlock>
  );
};

export default Index;
